module.exports = __webpack_public_path__ + "img/Unicom-3.0261791c.svg";